import axios from "axios";
import { request, gql, GraphQLClient } from 'graphql-request';
import {
  ADD_PRIVATE_COMMENT,
  CREATE_CLASS_QUIZ,
  DELETE_CLASS_QUIZ,
  GET_ALL_FILTERED_QUIZ_SUBMISSIONS,
  GET_ALL_QUIZ_SUBMISSIONS,
  GET_INDIVIDUAL_QUIZ,
  GET_INDIVIDUAL_QUIZ_SUBMISSIONS,
  GET_QUIZ_LIST,
  GET_QUIZ_STUDENT_LIST,
  GET_STUDENT_INDIVIDUAL_QUIZ,
  GET_STUDENT_QUIZ_SUBMISSION,
  REMOVE_STUDENT_SUBMISSION,
  SAVE_QUIZ_MARKS,
  SUBMIT_QUIZ_SOLUTION,
  UPDATE_CLASS_QUIZ,
  UPDATE_STUDENT_QUIZ_SOLUTION,
  RETURN_QUIZ_MARKS,
  GET_STUDENT_QUIZ_LIST,
  PROGRESS_BAR_COUNT_QUIZ,
  IS_LOADING_QUIZ,
  ERROR_STATUS_CODE,
  CLEAR_QUIZ_SUBMISSION,
  DISPLAY_PRIVATE_COMMENT_ASSIGNMENT,
  DISPLAY_PRIVATE_COMMENT_QUIZ
} from "../constants/actionTypes";
import { PUT_QUIZ_API, GET_QUIZ_LIST_API } from "../constants/apis";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { store } from "../store";
import { handleErrorMessage } from "./classes";
import { handleSuccessMessage } from "./success";
import i18n from "../../i18nextConf";
import quiz from "../reducers/quiz";

export const getAllQuizzes = (classId, type) => {
  const token = store.getState()?.profile?.user?.token;
  let idType;
  if (type == "group") {
    idType = "group_id";
  } else {
    idType = "class_id";
  }
  let lang = window.localStorage.getItem("i18nextLng");
    if (lang == "en-US") {
      lang = "en";
    }
  return async (dispatch) => {
    await axios
      .get(`${GET_QUIZ_LIST_API}?${idType}=${classId}&?target=${lang}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          const quizzes = response?.data?.data.sort((a, b) => {
            return b.id - a.id;
          });
          dispatch({ type: GET_QUIZ_LIST, payload: quizzes });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const studentIndividualQuiz = (id) => {
  const token = store.getState()?.profile?.user?.token;
  let lang = window.localStorage.getItem("i18nextLng");
    if (lang == "en-US") {
      lang = "en";
    }
  return async (dispatch) => {
    await axios
      .get(`${GET_STUDENT_INDIVIDUAL_QUIZ_API}${id}/?target=${lang}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          const quizInd = response?.data?.data;
          if (response?.data?.data?.submission_id !== null && response?.data?.data?.submission_id !== undefined) {
            dispatch(
              getQuizStudentSubmission(response?.data?.data?.submission_id)
            );
          } else {
            dispatch({ type: REMOVE_STUDENT_SUBMISSION, payload: null });
          }
          dispatch({ type: GET_STUDENT_INDIVIDUAL_QUIZ, payload: quizInd });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const getQuizStudentSubmission = (submissionId) => {
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    await axios
      .get(`${GET_STUDENT_QUIZ_SUBMISSION_API}${submissionId}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          const submission = response?.data?.data;
          dispatch({ type: GET_STUDENT_QUIZ_SUBMISSION, payload: submission });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

// Fixed Quiz Submission Functions based on the actual GraphQL schema

// Updated submitQuizSolution to match yucampus format
export const submitQuizSolution = (submissionData) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  // GraphQL mutation matching yucampus format exactly
  const mutation = gql`
    mutation ($id: ID!, $input: QuizSubmissionUpdateInput!) {
      update_quiz_submission(id: $id, input: $input) {
        id    
        quiz {
          id
          template {
            id
            title
          }
          classes{
            id
            name
          }
          quiz_owner{
            id
            name
          }
          title
          details
          submission_count {
            assigned
            submitted
            graded
          }
          max_marks
          show_answers
          is_active
          is_timed
          duration
          cut_off_score
          question_randomized
          reattempt
          due_date
          is_lock
          timestamp
          utimestamp
        }
        students {
          id
          name
        }
        attempt
        submission_status
        marks
        time_taken
        user_answers
        is_returned
        is_submitted
        submission_date
      }
    }
  `;

  // Variables format matching yucampus
  const variables = {
    id: submissionData.submissionId.toString(), // Ensure it's a string like "163"
    input: {
      user_answers: submissionData.userAnswers
    }
  };

  return async (dispatch) => {
    dispatch({ type: IS_LOADING_QUIZ, payload: true });
    
    try {
      console.log('GraphQL Variables:', variables); // Debug log
      
      const response = await client.request(mutation, variables);
      
      if (response?.update_quiz_submission) {
        const submission = response.update_quiz_submission;
        dispatch({ type: SUBMIT_QUIZ_SOLUTION, payload: submission });
        dispatch(
          handleSuccessMessage(
            i18n.t("quizSuccessMessages.quizSubmittedSuccessfully")
          )
        );
      }
      
      dispatch({ type: IS_LOADING_QUIZ, payload: false });
      return response;
      
    } catch (error) {
      console.error('GraphQL Error:', error);
      dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors?.[0]?.message || error.message)));
      dispatch({ type: IS_LOADING_QUIZ, payload: false });
      throw error;
    }
  };
};

// Updated updateStudentQuizSolution to match yucampus format
export const updateStudentQuizSolution = (data) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      "Authorization": `Token ${token}`,
    },
  });

  // If no file or URL to update, just show success message
  if (!data?.file?.name && !data?.url && !data?.userAnswers?.length) {
    return async (dispatch) => {
      dispatch(
        handleSuccessMessage(
          i18n.t("quizSuccessMessages.quizUpdatedSuccessfully")
        )
      );
    };
  }

  const mutation = gql`
    mutation ($id: ID!, $input: QuizSubmissionUpdateInput!) {
      update_quiz_submission(id: $id, input: $input) {
        id
        quiz {
          id
          template {
            id
            title
          }
          classes {
            id
            name
          }
          quiz_owner {
            id
            name
          }
          title
          details
          submission_count {
            assigned
            submitted
            graded
          }
          max_marks
          show_answers
          is_active
          is_timed
          duration
          cut_off_score
          question_randomized
          reattempt
          due_date
          is_lock
          timestamp
          utimestamp
        }
        students {
          id
          name
        }
        attempt
        submission_status
        marks
        time_taken
        user_answers
        is_returned
        is_submitted
        submission_date
      }
    }
  `;

  const variables = {
    id: data.submissionId.toString(), // Ensure it's a string
    input: {
      user_answers: data.userAnswers
    }
  };

  return async (dispatch) => {
    dispatch({ type: IS_LOADING_QUIZ, payload: true });
    
    try {
      const response = await client.request(mutation, variables);

      // NEW: Handle GraphQL soft errors (null + errors array)
      if (!response?.update_quiz_submission) {
        const errorMsg =
          response?.errors?.[0]?.formatted_message ||
          response?.errors?.[0]?.message ||
          "Quiz submission failed. Please try again.";

        dispatch(handleErrorMessage(errorMsg));
        dispatch({ type: IS_LOADING_QUIZ, payload: false });
        throw new Error(errorMsg); // let QuizModal also catch it
      }

      const submission = response.update_quiz_submission;
      dispatch({ type: SUBMIT_QUIZ_SOLUTION, payload: submission });
      dispatch(
        handleSuccessMessage(
          i18n.t("quizSuccessMessages.quizSubmittedSuccessfully")
        )
      );

      dispatch({ type: IS_LOADING_QUIZ, payload: false });
      return response;
      
    } catch (error) {
      dispatch(handleErrorMessage(errorMessageFromResponse(error?.response?.errors?.[0]?.message || error.message)));
      dispatch({ type: IS_LOADING_QUIZ, payload: false });
      throw error;
    }
  };
};

export const clearQuizSubmission = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_QUIZ_SUBMISSION, payload: {} });
  };
};

// Teachers quiz actions

export const createQuiz = (formData, type) => {
  const token = store.getState()?.profile?.user?.token;
  let data = new FormData();
  if (type == "group") {
    data.append("groups", formData.classes);
  } else {
    data.append("classes", formData.classes);
  }
  data.append("title", formData.title);
  data.append("details", formData.details);
  data.append("max_marks", formData.max_marks);
  data.append("due_date", formData.due_date);
  data.append("is_lock", formData.is_lock);
  if (formData.url != null) {
    data.append("url", formData.url);
  }
  if (formData.file != null) {
    data.append("file", formData.file);
  }
  return async (dispatch) => {
    await axios({
      method: "post",
      url: `${POST_QUIZ_API}`,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          dispatch({
            type: CREATE_CLASS_QUIZ,
            Ppayload: response.data.data,
          });
          dispatch(
            handleSuccessMessage(
              i18n.t("quizSuccessMessages.quizCreatedSuccessfully")
            )
          );
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
      });
  };
};

export const getIndividualQuiz = (id) => {
  const token = store.getState()?.profile?.user?.token;
  let lang = window.localStorage.getItem("i18nextLng");
    if (lang == "en-US") {
      lang = "en";
    }
  return async (dispatch) => {
    await axios
      .get(`${GET_INDIVIDUAL_QUIZ_API}${id}/?target=${lang}/`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          dispatch({
            type: GET_INDIVIDUAL_QUIZ,
            payload: response?.data?.data,
          });
        }
      })
      .catch(async (error) => {
        if(error.response.status === 400){
          dispatch({
            type: ERROR_STATUS_CODE,
            payload: error.response.status,
          })
        } else {
          dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        }        
        return error;
      });
  };
};

export const updateQuiz = (formData, type) => {
  const token = store.getState()?.profile?.user?.token;
  const url = `${PUT_QUIZ_API}${formData.id}/`;

  return async (dispatch) => {
    let data = new FormData();
    data.append("title", formData.title);
    data.append("details", formData.details);
    data.append("max_marks", formData.max_marks);
    data.append("due_date", formData.due_date);
    data.append("is_lock", formData.is_lock);
    if (formData.url != null) {
      data.append("url", formData.url);
    }
    //   data.append("file", formData.file);
    if (type == "group") {
      data.append("groups", formData.classes);
    } else {
      data.append("classes", formData.classes);
    }

    await axios({
      method: "put",
      url: url,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          dispatch({
            type: UPDATE_CLASS_QUIZ,
            payload: response.data.data, // Payload
          });

          dispatch(
            handleSuccessMessage(
              i18n.t("quizSuccessMessages.quizUpdatedSuccessfully")
            )
          );
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const deleteQuiz = (id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = process.env.REACT_APP_GRAPHQL_BASE_URL;

  const client = new GraphQLClient(endpoint, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  const query = `
    mutation ($input: ID!) {
      delete_quiz(id: $input)
    }
  `;

  const variables = {
    input: id,
  };

  return async (dispatch) => {
    try {
      const response = await client.request(query, variables);

      // GraphQL mutation returns response.delete_quiz (true/ID/whatever backend returns)
      if (response && response.delete_quiz) {
        dispatch({ type: DELETE_CLASS_QUIZ, payload: id });
        dispatch(
          handleSuccessMessage(i18n.t("quizSuccessMessages.quizDeletedSuccessfully"))
        );
      } else {
        // If API returns falsy value, surface a friendly error
        dispatch(
          handleErrorMessage(i18n.t("errorMessageTranslations.cantDeleteError"))
        );
      }
    } catch (error) {
      // try to extract a formatted message like your example
      const formatted = error?.response?.errors?.[0]?.formatted_message;
      const errMsg = errorMessageFromResponse(formatted) || error?.message || i18n.t("errorMessageTranslations.cantDeleteError");

      dispatch(handleErrorMessage(errMsg));
      return error;
    }
  };
};


// export const deleteQuiz = (id) => {
//   const token = store.getState()?.profile?.user?.token;
//   return async (dispatch) => {
//     await axios({
//       method: "delete",
//       url: `${DELETE_QUIZ_API}${id}/`,
//       headers: {
//         Authorization: `Token ${token}`,
//       },
//     })
//       .then((response) => {
//         if (response.status >= 200 && response.status < 300) {
//           dispatch({ type: DELETE_CLASS_QUIZ, payload: id });
//           dispatch(
//             handleSuccessMessage(
//               i18n.t("quizSuccessMessages.quizDeletedSuccessfully")
//             )
//           );
//         }
//       })
//       .catch(async (error) => {
//         dispatch(
//           handleErrorMessage(
//             i18n.t("errorMessageTranslations.cantDeleteError"),
//             ": ",
//             error
//           )
//         );
//         return error;
//       });
//   };
// };

export const getQuizStudentList = (id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = `${GET_QUIZ_STUDENT_LIST_API}?quiz_id=${id}`;

  return async (dispatch) => {
    await axios
      .get(endpoint, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          const student_list = response.data.data;
          dispatch({
            type: GET_QUIZ_STUDENT_LIST,
            payload: student_list,
          });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const returnQuizMarks = (data) => {
  const token = store.getState()?.profile?.user?.token;

  return async (dispatch) => {
    const url = `${RETURN_QUIZ_MARKS_API}`;

    await axios({
      method: "put",
      url: url,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          dispatch({
            type: RETURN_QUIZ_MARKS,
            payload: data.submission_list,
          });
          dispatch(
            handleSuccessMessage(
              i18n.t("quizSuccessMessages.returnSuccessMessage")
            )
          );
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const saveQuizMarks = (formData) => {
  const token = store.getState()?.profile?.user?.token;

  return async (dispatch) => {
    let data = new FormData();
    data.append("marks", formData.marks);

    const url = `${SAVE_QUIZ_MARKS_API}${formData.id}/`;

    await axios({
      method: "put",
      url: url,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          dispatch({
            type: SAVE_QUIZ_MARKS,
            payload: response.data.data,
          });
          dispatch(
            handleSuccessMessage(
              i18n.t("quizSuccessMessages.quizGradedSuccessfully")
            )
          );
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const getAllQuizSubmissions = (quiz_id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = `${GET_ALL_QUIZ_SUBMISSIONS_API}?quiz_id=${quiz_id}`;

  return async (dispatch) => {
    await axios
      .get(endpoint, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          const quiz_submissions = response.data.data;

          dispatch({
            type: GET_ALL_QUIZ_SUBMISSIONS,
            payload: quiz_submissions,
          });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

// ------------------ Get All Filtered Assignment Submissions ---------

export const getAllFilteredQuizSubmissions = (quiz_id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = `${GET_ALL_QUIZ_SUBMISSIONS_API}?quiz_id=${quiz_id}`;

  return async (dispatch) => {
    await axios
      .get(endpoint, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          const quiz_submissions = response.data.data;

          const filtered_submissions_list = quiz_submissions.filter(
            (item) =>
              item.submission_status === "SUB" ||
              item.submission_status === "DL"
          );

          dispatch({
            type: GET_ALL_FILTERED_QUIZ_SUBMISSIONS,
            payload: filtered_submissions_list,
          });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

// ----------------

export const getIndividualQuizSubmission = (submission_id) => {
  const token = store.getState()?.profile?.user?.token;
  const endpoint = `${GET_INDIVIDUAL_QUIZ_SUBMISSIONS_API}${submission_id}/`;

  return async (dispatch) => {
    await axios
      .get(endpoint, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.status == "1" &&
          response.status >= 200 &&
          response.status < 300
        ) {
          const quiz_submission = response.data.data;
          dispatch({
            type: GET_INDIVIDUAL_QUIZ_SUBMISSIONS,
            payload: quiz_submission,
          });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

export const getStudentQuizList = (id, type) => {
  const token = store.getState()?.profile?.user?.token;
  let idType = "";
  if (type === "group") {
    idType = "group_id";
  } else {
    idType = "class_id";
  }
  return async (dispatch) => {
    await axios
      .get(`${GET_STUDENT_QUIZ_LIST_API}?${idType}=${id}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          const assignments = response?.data?.data;
          dispatch({ type: GET_STUDENT_QUIZ_LIST, payload: assignments });
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};

//post quiz and assignment comments api call action
export const addPrivateComment = (type, comment, quiz_id, student_id) => {
  console.log('insideAdd', {type, comment, quiz_id, student_id});
  const token = store.getState()?.profile?.user?.token;
  let data = new FormData();
  data.append(type === "QUIZ" ? "quiz" : "assignment", quiz_id);
  data.append("student_access", student_id);
  data.append("description", comment);

  return async (dispatch) => {
    await axios({
      method: "post",
      url: type === "QUIZ" ? `${POST_QUIZ_COMMENTS}` : `${POST_ASS_COMMENTS}`,
      data: data,
      headers: {
        Authorization: `Token ${token}`,
      },
    }).then((response) => {
      if (
        response.data.status == "1" &&
        response.status >= 200 &&
        response.status < 300
      ) {
        dispatch({
          type: ADD_PRIVATE_COMMENT,
          payload: response.data.data,
        });
      }
    });
  };
};

//get quiz and assignment comments api call action
export const getPrivateComment = (type, quiz_id, student_id = 357) => {
  console.log('insideCommentAction', {type, quiz_id, student_id})
  const token = store.getState()?.profile?.user?.token;
  return async (dispatch) => {
    await axios
      .get(
        type === "QUIZ"
          ? `${GET_QUIZ_COMMENTS}=${quiz_id}&student_access=${student_id}`
          : `${GET_ASS_COMMENTS}=${quiz_id}&student_access=${student_id}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((response) => {
        if (
          response?.status >= 200 &&
          response?.status < 300 &&
          response?.data?.status == "1"
        ) {
          if(type === "QUIZ"){
            dispatch({
              type: DISPLAY_PRIVATE_COMMENT_QUIZ,
              payload: response.data.data,
            });

          } else {
            dispatch({
              type: DISPLAY_PRIVATE_COMMENT_ASSIGNMENT,
              payload: response.data.data,
            });

          }
          
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
};